import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga";
import tasksSaga from "./tasks/saga"
import companiesSaga from "./companies/saga"
import plansSaga from "./plans/saga"
import systemUsersSaga from "./systemUsers/saga"
import rolesSaga from "./roles/saga"
import permissionsSaga from "./permissions/saga"
import dashboardAdminSaga from "./dashboardAdmin/saga"
import invoicesAdminSaga from "./invoicesAdmin/saga"
import settingsAdminSaga from "./settingsAdmin/saga"
import ticketsAdminSaga from "./ticketsAdmin/saga"
import customersSaga from "./customers/saga"
import companyUsersSaga from "./companyUsers/saga"
import invoicesSaga from "./invoices/saga"
import productSaga from "./products/saga"
import quoteSaga from "./quotes/saga"
import ticketSaga from "./tickets/saga"
import dashboardCompanySaga from "./dashboardCompany/saga"
import supplierSaga from "./suppliers/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(calendarSaga),
    fork(tasksSaga),
    fork(chatSaga),
    fork(companiesSaga),
    fork(plansSaga),
    fork(systemUsersSaga),
    fork(rolesSaga),
    fork(permissionsSaga),
    fork(dashboardAdminSaga),
    fork(invoicesAdminSaga),
    fork(settingsAdminSaga),
    fork(ticketsAdminSaga),
    fork(customersSaga),
    fork(companyUsersSaga),
    fork(invoicesSaga),
    fork(productSaga),
    fork(quoteSaga),
    fork(ticketSaga),
    fork(dashboardCompanySaga),
    fork(supplierSaga),
  ])
}
